/**
 * Міксін для логіки вибору елементів (selected) в таблицях пропозицій.
 */
export default {
  data() {
    return {
      selected: [],
    }
  },
  props: {
    selecting: Function,
    group: Object,
  },
  methods: {
    onSelectionChange(val) {
      if (this.group && this.selecting) {
        this.selecting(val, this.group)
      }
    },
    toggleSelectAllFunc(arg) {
      this.selected = arg.value ? (this.group?.items || []).slice(0) : []
    },
    clearSelection() {
      this.selected = []
    },
  },
  watch: {
    selected(val, old) {
      if (val?.length === old?.length) {
        return
      }
      this.onSelectionChange(val)
    },
  },
  mounted() {
    if (this.group?.selected?.length) {
      this.selected = this.$_.cloneDeep(this.group.selected)
    }
    this.$root.$on('closeSnackbar', this.clearSelection)
  },
  beforeDestroy() {
    this.$root.$off('closeSnackbar', this.clearSelection)
  },
}
